import { Form, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { SimpleFormField } from "../components/SimpleFormField";
import { User } from "../models/User";
import { useProfile, useWindowSettings } from "../components/ProfileContext";
import { Link } from "react-router-dom";
import { Api } from "../util/Api";
import { LoadingComponent } from "../components/LoadingComponent"
//import login_background from "../images/backgrounds"
import equipment_inspection_logo from '../images/equipment_inspection_logo.svg'
import { getPlatform, setNavAdvisoryLockout } from "../util/utils";
export function LoginPage(props) {
	setNavAdvisoryLockout(false);

	let queryParams = new URLSearchParams(useLocation().search);
    let navigate = useNavigate();
    let [profile, setProfile] = useProfile();
	let [windowSettings, setWindowSettings] = useWindowSettings();

	// This starts false because of iOS issues
	let [shouldShowCreateAccount, setShouldShowCreateAccount] = useState(false);

	let loginToken = queryParams.get('loginToken');
	let displayMode = queryParams.get("displayMode");

	if(!!displayMode && !!windowSettings) {
		if(windowSettings.context != displayMode) {
			windowSettings.context = displayMode;
			setWindowSettings(windowSettings);
			window.sessionStorage.setItem("displayContext", displayMode);
		}	
	}
	
	useEffect(async () => {
		if(!!loginToken) {
			try {
				let user = await Api.userForToken(loginToken);
				setProfile(user);	
				await User.saveUser(user);

				navigate("/dashboard");
			} catch(err) {
				console.log(`Error getting user data for token: ${err}`);
				navigate("/login"); // Get rid of token
			}
		}
		setTimeout(() => {
			setShouldShowCreateAccount(getPlatform() != "ios");
		}, 100);
	});

	if(!!loginToken) {
		return <LoadingComponent />
	}

	let login = async function(evt) {
		evt.preventDefault();

		if(!navigator.onLine) {
			alert("Must be connected to the Internet to login");
			return;
		}

		let data = new FormData(evt.target);
		try {
			let user = await Api.vaultLogin(data.get("username"), data.get("password"));
			await user.loadPreviousSessionDataIfRelevant();
			await User.saveUser(user);
			setProfile(user);
			navigate("/dashboard");
		} catch(err) {
			alert(`Error logging in: ${err}`);
		}
	}
    return (
        <div className="container">
			<div className="imageContainer">
				<img src={equipment_inspection_logo} className="header-logo"/>
			</div>
			<Form onSubmit={login}>
				<SimpleFormField type="text" name="username" label="McElroy Vault™ Username" />
				<SimpleFormField type="password" name="password" label="Password" />
				<Button  className="loginButton" type="submit">Login</Button>
			</Form>
			
			{/* App Store is harder with account creation */}
			{shouldShowCreateAccount && <p className="createCredential">
				Need an account?  Create one at the <a href="https://vault.mcelroy.com/" target="_blank">Vault™</a>
			</p>}

			<p className="searchInspection mt-4">
				<Link to="/inspections/search">Search for an Inspection</Link>
			</p>
			
        </div>
    )
}